module.exports = __webpack_public_path__ + "3521d4f45b4e4c8531d5a18242351cc7.pdf";